import IntelsatDonutChart from "@components/charts/IntelsatDonutChart";
import CustomAccordion from "@components/common/CustomAccordion";
import { useIsMobile } from "@components/mediaQuery/useIsMobile";
import { useState } from "react";
import { useSelector } from "react-redux";

const Intelsat = () => {
	const loadingVesselDetailsIntelsat = useSelector(
		(state) => state.modules?.vessels?.intelsats?.loading,
	);
	const intelsatData = useSelector((state) => state.modules?.vessels?.intelsat?.data);
	const { terminal_id, plan, usage, terminal_name } = useSelector(
		(state) => state.modules?.vessels?.intelsat?.data?.[0],
	);

	const [openAccordions, setOpenAccordions] = useState({
		"credit-0": true,
		"usage-0": false,
		"telemetry-0": false,
	});
	const toggleAccordion = (id) => {
		setOpenAccordions((prevState) => ({
			...prevState,
			[id]: !prevState[id],
		}));
	};
	const isMobile = useIsMobile();

	return (
		<div>
			{loadingVesselDetailsIntelsat ? (
				<div className="flex h-64 items-center justify-center">
					<div className="h-32 w-32 animate-spin rounded-full border-gray-700 border-t-2 border-b-2"></div>
				</div>
			) : intelsatData.length > 0 ? (
				<div className="grid grid-cols-1 gap-4 md:grid-cols-1">
					<div
						className={`chart-column first-column ${openAccordions[`credit-0`] ? "bg-[#1F2A37]" : ""} rounded-lg border-t-0`}
					>
						<CustomAccordion
							id={`credit-0`}
							title={`Intelsat Usage - ${terminal_name}`}
							isOpen={openAccordions[`credit-0`]}
							toggleAccordion={() => toggleAccordion(`credit-${index}`)}
							isMobile={isMobile}
						>
							<IntelsatDonutChart
								id={`credit_limit-0`}
								allowanceValue={plan}
								allowanceCurrentValue={usage}
							/>
						</CustomAccordion>
					</div>
				</div>
			) : (
				<div className="grid grid-cols-1 gap-4 md:grid-cols-1">
					<div className="flex flex-col gap-2">
						<div className="flex items-center gap-2">
							<span className="text-gray-400 text-sm">No Intelsat</span>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default Intelsat;
